import { Directive, Input, OnInit, OnDestroy, TemplateRef, ViewContainerRef } from '@angular/core';
import { Subject, takeUntil } from 'rxjs';
import { GroupService } from '../../core/services/group.service';

export interface SpecialtyCondition {
  specialties: string[];
  condition: 'include' | 'exclude';
}

@Directive({
  selector: '[appGroupSpecialtyHideStructural]',
  exportAs: 'appGroupSpecialtyHideStructural'
})
export class GroupSpecialtyHideStructuralDirective implements OnInit, OnDestroy {
  @Input('appGroupSpecialtyHideStructural') condition!: SpecialtyCondition;
  
  private destroy$ = new Subject<void>();
  private hasView = false;

  constructor(
    private templateRef: TemplateRef<any>,
    private viewContainer: ViewContainerRef,
    private groupService: GroupService
  ) {}

  ngOnInit() {
    this.groupService.selectedGroup$
      .pipe(takeUntil(this.destroy$))
      .subscribe(selectedGroup => {
        if (selectedGroup) {
          this.checkSpecialtyCondition(selectedGroup);
        }
      });
  }

  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
  }

  private checkSpecialtyCondition(group: any) {
    if (!this.condition || !group.groupSpeciality) {
      this.showElement();
      return;
    }

    const { specialties, condition } = this.condition;
    const groupSpecialty = group.groupSpeciality;
    const isInList = specialties.includes(groupSpecialty);

    let shouldHide = false;

    if (condition === 'include') {
      // Hide if the group specialty is NOT in the list
      shouldHide = !isInList;
    } else if (condition === 'exclude') {
      // Hide if the group specialty IS in the list
      shouldHide = isInList;
    }

    if (shouldHide) {
      this.hideElement();
    } else {
      this.showElement();
    }
  }

  private hideElement() {
    if (this.hasView) {
      this.viewContainer.clear();
      this.hasView = false;
    }
  }

  private showElement() {
    if (!this.hasView) {
      this.viewContainer.createEmbeddedView(this.templateRef);
      this.hasView = true;
    }
  }
} 